<template>
  <header class="header">
    <div class="flex items-center justify-between w-full p-4 px-8">
      <a
        href="https://www.harmonix.ai"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="@/assets/whiteLogo.png" alt="Harmonix Logo" class="logo" />
      </a>
      <div class="header-right">
        <a
          href="https://auth.bloobirds.com/auth/login"
          target="_blank"
          rel="noopener noreferrer"
          class="sign-in-button ta"
          >Iniciar sesión</a
        >
      </div>
    </div>
  </header>
</template>

<script setup></script>

<style scoped lang="postcss">
.header {
  @apply relative overflow-hidden text-white;
  height: 20vh;
}

.logo {
  @apply h-auto w-[14.75rem] relative z-[5] pt-8;
}

@media (max-width: 1024px) {
  .logo {
    @apply w-[10.5rem];
  }
}

@media (max-width: 768px) {
  .logo {
    @apply w-[10.25rem];
  }
}

@media (max-width: 480px) {
  .logo {
    @apply w-[7.375rem];
  }
}

.header-right {
  @apply flex items-center gap-8 mr-16 relative z-[5];
}

.sign-in-button {
  @apply py-2 px-6 border border-white rounded-[20px] bg-transparent text-white cursor-pointer transition-all duration-300;
  font-family: inherit;
}

.sign-in-button:hover {
  @apply bg-white text-[#0a0f29];
}

@media (max-width: 1024px) {
  .header-right {
    @apply mr-8 gap-6;
  }

  .logo {
    @apply max-w-[140px];
  }
}

@media (max-width: 768px) {
  .header {
    @apply p-4;
  }

  .header-right {
    @apply gap-4 mr-4;
  }

  .sign-in-button {
    @apply py-[0.4rem] px-4 text-base;
  }

  .logo {
    @apply max-w-[140px];
  }
}

@media (max-width: 480px) {
  .header {
    @apply flex-col gap-4 py-4 px-2;
  }

  .header-right {
    @apply w-full justify-between mr-0 px-2;
  }

  .sign-in-button {
    @apply text-sm py-[0.3rem] px-[0.8rem];
  }
  .logo {
    @apply max-w-[120px];
  }
}
</style>
